import { useJxtRouter } from '../routing/context';
import { isGuestRoute } from '../routing/helpers';
import { useRtsmCodeStore } from './rtsm-code.store';
import { useDefaultStore } from './default.store';
import { useMemo } from 'react';
import { JooxterState } from './types';
import { useShallow } from 'zustand/shallow';

export const useStore = <U>(selector: (state: JooxterState) => U) => {
  const {
    location: { pathname },
    matchPath,
  } = useJxtRouter();

  const defaultState = useDefaultStore(useShallow(selector));
  const rtsmState = useRtsmCodeStore(useShallow(selector));
  const shouldUseRtsmStore = isGuestRoute(pathname, matchPath);

  return useMemo(() => (shouldUseRtsmStore ? rtsmState : defaultState), [shouldUseRtsmStore, rtsmState, defaultState]);
};
